export enum TextSizeEnum {
    SMALL = 'SMALL',
    NORMAL = 'NORMAL',
    LARGE = 'LARGE',
    EXTRALARGE = 'EXTRALARGE'
}
